export default "__VITE_PUBLIC_ASSET__dd0c0a5f__"